import type { MetaFields } from '@dutchiesdk/ecommerce-extensions-sdk';

/**
 * True when the remote theme supplies an og:image, either through the typed `ogImage` field or as
 * an `og:image` entry in `customMeta`. Host tags use this to drop their own og:image so only the
 * theme's image reaches the DOM.
 */
export const hasThemeOgImage = (metaFields: MetaFields | null | undefined): boolean =>
  Boolean(metaFields?.ogImage?.trim()) ||
  Boolean(
    metaFields?.customMeta?.some(
      (meta) => (meta.property ?? meta.name ?? '').toLowerCase() === 'og:image' && Boolean(meta.content?.trim())
    )
  );
